module.exports = __webpack_public_path__ + "fonts/gothica1-medium-webfont.ce902d5.woff";